import { TranslationService } from '@/utils/services';

import { MANAGE_MENTIONS_TRACKER } from '@/lib/routes/privateRoutes';

export { default } from '@/pages/conversations/comments';

export const getStaticProps =
    TranslationService.getTranslationMessagesFromRoute(MANAGE_MENTIONS_TRACKER);
